import moment from 'moment'
import {CrudProvider} from '../../../../services/loggedin/CrudContext'
import {ChartsComponent} from '../../../parts/crud/Charts'
import {getBaseBarChartOptions} from '../../../parts/crud/Types'
import {useIntl} from 'react-intl'
import { useEffect, useState } from 'react'

export const WidgetDiagnosticOccurrencies = (props:any) => {
  const intl = useIntl()
  const days = props && props.days ? props.days : 7
  const [filterData, setFilterData] = useState<any>({});

  useEffect(() => {
    const newFilterData = {
      event_is_open: 1,
      server: 'all',
      tz: new Date().getTimezoneOffset(),
      date_range: {
        start: moment().subtract(days, 'days'),
        end: moment(),
      },
    };
    setFilterData(newFilterData);
  }, [days]); 
 /* const filterData = {
    event_is_open: 1,
    server: 'all',
    tz: new Date().getTimezoneOffset(),
    date_range: {
      start: moment().subtract(days, 'days'),
      end: moment(),
    },
  }
    */





  let params: any = {
    title: intl.formatMessage({id: 'DIAGNOSTIC.DIAGNOSTIC_EVENTS_OCCURRENCIES.TITLE'}),
    yAxisTitle: intl.formatMessage({id: 'DIAGNOSTIC.DIAGNOSTIC_EVENTS_OCCURRENCIES.YAXISTITLE'}),
    subtitle: intl.formatMessage({id: 'GENERIC.X_GIORNI_PRECEDENTI'}).replace('{x}', days) ,
    headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
    pointFormat:
      '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
      '<td style="padding:0"><b>{point.y:.0f} </b></td></tr>',
    footerFormat: '</table>',
    shared: true,
    useHTML: true,
  }
  let baseChartOptions: any = {...getBaseBarChartOptions(params)}
  baseChartOptions.plotOptions = {
    column: {
      stacking: 'normal',
      minPointLength: 5,
    },
  }
  baseChartOptions.legend = {
    layout: 'vertical',
    align: 'left',
    verticalAlign: 'top',
    x: 150,
    y: 100,
    title: {
      text: intl.formatMessage({id: 'DIAGNOSTIC.DIAGNOSTIC_EVENTS_OCCURRENCIES.LEGEND_TITLE'}),
    },
    floating: true,
    draggable: true,
    borderWidth: 1,
    backgroundColor: '#FFFFFF',
  }
  if(!filterData || Object.keys(filterData).length===0){
    return <></>
  }
  return (
    <>
      <CrudProvider api='diagnostic/events-occurrencies'>
      
        <ChartsComponent
          disableError={true}
          filterData={filterData}
          chartOnly='true'
          baseChartOptions={baseChartOptions}
        ></ChartsComponent>
      </CrudProvider>
    </>
  )
}
